import { Box, Flex, Image, Text } from "@chakra-ui/react";
import iconApproved from "../../../assets/images/receiveSalary/check-circle.svg";
import iconRejected from "../../../assets/images/contract/x-circle.svg";

export const formatTableValue = (value, key) => {
  switch (key) {
    case "dateTime":
      return <Text>{value}</Text>;
    case "checkinTime":
      return <Text>{value}</Text>;
    case "code":
      return <Text>{value}</Text>;
    case "fullName":
      return <Text>{value}</Text>;
    case "name":
      return <Text>{value}</Text>;
    case "workingDayRate":
      return <Text>{value}</Text>;
    case "block":
      return <Text>{value}</Text>;
    case "reason":
      return <Text>{value}</Text>;
    case "start":
      return (
        <Box>
          <Text textAlign={"start"}>{value[0]}</Text>
          <Text mt={"4px"} textAlign={"start"}>
            {value[1]}
          </Text>
        </Box>
      );
    case "end":
      return (
        <Box>
          <Text textAlign={"start"}>{value[0]}</Text>
          <Text mt={"4px"} textAlign={"start"}>
            {value[1]}
          </Text>
        </Box>
      );
    case "isCompleted":
      let content;
      if (value === true) {
        content = (
          <>
            <Image src={iconApproved} />
            <Text color={"var(--color-status-employ)"}>Đã hoàn thành</Text>
          </>
        );
      } else {
        content = (
          <>
            <Image src={iconRejected} />
            <Text color={"var(--text-red-employee)"}>Chưa hoàn thành</Text>
          </>
        );
      }

      return (
        <Flex gap={"8px"} w={"max-content"}>
          {content}
        </Flex>
      );
    default:
      return <Text>{value}</Text>;
  }
};
